import { useEffect, useState } from "react";

import { fetchPublicTournament } from "./tournamentApi";

/** Polls the public tournament feed every 15s (ETag revalidation; backs off on 429). */
export function usePublicTournament(slug) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  useEffect(() => {
    let active = true;
    let timer;
    let last = null;
    async function tick() {
      let wait = 15000;
      try {
        const d = await fetchPublicTournament(slug, last);
        last = d;
        if (active) { setData(d); setError(null); setUpdatedAt(new Date()); }
      } catch (e) {
        if (active) setError(e.message);
        if (e.status === 429) wait = 30000 + Math.random() * 15000;
      }
      if (active) timer = setTimeout(tick, wait);
    }
    tick();
    return () => { active = false; if (timer) clearTimeout(timer); };
  }, [slug]);
  return { data, error, updatedAt };
}
